// ** Redux Toolkit
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// ** Axios (your custom instance)
import axios from '@src/service/axios'

// ** Toast
import { toast } from 'react-toastify'

// ** Auth Config
import authConfig from '@src/auth/config.js'

// ** Constants
import service from '@src/service/constant'

 
//   GET COMPANY DETAILS
 
export const getCompanyDetails = createAsyncThunk(
  'company/getCompanyDetails',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('/company', {
        headers: {
          'Content-Type': 'application/json',
          isLoggedIn:
            localStorage.getItem(authConfig.storageUserDataKeyName) &&
            localStorage.getItem(authConfig.storageTokenKeyName)
              ? true
              : false
        }
      })

      let data = response.data

      // OPTIONAL: handle logo URL if needed
      if (data?.logo) {
        data.logo = data.logo
      }

      // Save in localStorage (same pattern as your project)
      localStorage.setItem(
        authConfig.storageProjectSettingKeyName,
        JSON.stringify(data)
      )

      return data
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to fetch company')
      return rejectWithValue(err)
    }
  }
)

 
//   CREATE / UPDATE COMPANY
 
export const postCompanyDetails = createAsyncThunk(
  'company/postCompanyDetails',
  async (formData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/company', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          isLoggedIn:
            localStorage.getItem(authConfig.storageUserDataKeyName) &&
            localStorage.getItem(authConfig.storageTokenKeyName)
              ? true
              : false
        }
      })

      toast.success(response?.data?.message || 'Company saved successfully')

      // Refresh data after save
      dispatch(getCompanyDetails())

      return response.data
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to save company')
      return rejectWithValue(err)
    }
  }
)


const companySlice = createSlice({
  name: 'company',
  initialState: {
    companyDetails: null,
    loading: false,
    error: null
  },

  reducers: {
    clearCompany: (state) => {
      state.companyDetails = null
    }
  },

  extraReducers: (builder) => {

    // ================= GET =================
    builder
      .addCase(getCompanyDetails.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCompanyDetails.fulfilled, (state, action) => {
        state.loading = false
        state.companyDetails = action.payload
      })
      .addCase(getCompanyDetails.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

    // ================= POST =================
    builder
      .addCase(postCompanyDetails.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(postCompanyDetails.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(postCompanyDetails.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearCompany } = companySlice.actions
export default companySlice.reducer